
<!-- <div [@myAnimation]="o.isActivated ? o.activatedRoute : ''"> -->
<div [@routerTransition]="getState(o)">
    <router-outlet  #o="outlet"></router-outlet>
</div>